import { createContext, useContext } from "react";

import { useForm } from "react-hook-form";

import { FormData } from "../core/types";

export interface FormMethodsContextValue {
  formMethods: ReturnType<typeof useForm<FormData>>;
}

export const FormMethodsContext = createContext<FormMethodsContextValue | null>(
  null
);

export const useFormMethodsContext = (): FormMethodsContextValue => {
  const context = useContext(FormMethodsContext);
  if (!context) {
    throw new Error(
      "useFormMethodsContext must be used within a FormEngineProvider"
    );
  }
  return context;
};
